import { Navigate, Outlet } from 'react-router-dom';

const GuestGuard = () => {
  const token = localStorage.getItem('token');

  if (token) {
    return <Navigate to="/loading" replace />;
  }

  return <Outlet />;
};

export default GuestGuard;
